export default __webpack_public_path__ + "static/media/featured-01.4bb6a566.jpg";